import { USER_ROLE } from "../constants/common";

export const PERM_CHAT_WITH_DATA = 'CHAT_WITH_DATA';

export default class PermissionUtils {
  static hasPermission(user, perm) {
    return user?.access?.includes(perm);
  }

  // static hasCompanyAdminPermission(roles) {
  //   return roles.includes(USER_ROLE.SUBSCRIBER_ADMIN)
  //   || roles.includes(USER_ROLE.SUBSCRIBER_RISK_ASSESSOR)
  //   || roles.includes(USER_ROLE.SUBSCRIBER_TEAM_MEMBER)
  //   || roles.includes(USER_ROLE.CONSULTANT)
  //   || roles.includes(USER_ROLE.SUBSCRIBER_AI_POWERED_ADMIN);
  // }


  // static isCompanyAdmin(roles) {
  //   return roles.includes(USER_ROLE.SUBSCRIBER_ADMIN) 
  //   || roles.includes(USER_ROLE.SUBSCRIBER_AI_POWERED_ADMIN);
  // }

  static isSupplierAdmin(roles) {
    return roles.includes(USER_ROLE.SUPPLIER_ADMIN);
  }

  static isConsultant(roles) {
    return roles.includes(USER_ROLE.CONSULTANT);
  }

  static isSuperAdmin(roles) {
    return roles.includes(USER_ROLE.SUPER_ADMIN);
  }
// for Data Management
  static hasDMPeriodicViewPermission(roles) {
    return roles.includes(USER_ROLE.DM_VIEW_PERIODIC)
    || roles.includes(USER_ROLE.DM_UPDATE_PERIODIC)
   
  }

  static hasDMPeriodicUpdatePermission(roles) {
    return roles.includes(USER_ROLE.DM_UPDATE_PERIODIC)
  
  }

  static hasDMOneTimeViewPermission(roles) {
    return roles.includes(USER_ROLE.DM_VIEW_ONETIME)
    || roles.includes(USER_ROLE.DM_UPDATE_ONETIME)
   
  }

  static hasDMOneTimeUpdatePermission(roles) {
    return roles.includes(USER_ROLE.DM_UPDATE_ONETIME)  
   
  }

  //for reporting studio
  // static hasReportingStudioViewPermission(roles) {
  //   return roles.includes(USER_ROLE.REPORTING_STUDIO_VIEW)
  //   || roles.includes(USER_ROLE.REPORTING_STUDIO_UPDATE)
   
  // }
  // static hasReportingStudioUpdatePermission(roles) {
  //   return roles.includes(USER_ROLE.REPORTING_STUDIO_UPDATE)
   
  // }
  //for GRI
  static hasGRIViewPermission(roles) {
    return roles.includes(USER_ROLE.VIEW_GRI)
    || roles.includes(USER_ROLE.UPDATE_GRI)
  }
  static hasGRIUpdatePermission(roles) {
    return roles.includes(USER_ROLE.UPDATE_GRI)
  }
  //for BRSR
  static hasBRSRViewPermission(roles) {
    return roles.includes(USER_ROLE.VIEW_BRSR)
    || roles.includes(USER_ROLE.UPDATE_BRSR)
  }
  static hasBRSRUpdatePermission(roles) {
    return roles.includes(USER_ROLE.UPDATE_BRSR)
  }
  //for GHG
  static hasGHGReportViewPermission(roles) {
    return roles.includes(USER_ROLE.VIEW_GHG)
    || roles.includes(USER_ROLE.UPDATE_GHG)
  }
  static hasGHGReportUpdatePermission(roles) {
    return roles.includes(USER_ROLE.UPDATE_GHG)
  }
  //for CSRD
  static hasCSRViewPermission(roles) {
    return roles.includes(USER_ROLE.VIEW_CSRD)
    || roles.includes(USER_ROLE.UPDATE_CSRD)
  }
  static hasCSRUpdatePermission(roles) {
    return roles.includes(USER_ROLE.UPDATE_CSRD)
  }
  //for VSME
  static hasVSMEViewPermission(roles) {
    return roles.includes(USER_ROLE.VIEW_VSME)
    || roles.includes(USER_ROLE.UPDATE_VSME)
  }
  static hasVSMEUpdatePermission(roles) {
    return roles.includes(USER_ROLE.UPDATE_VSME)
  }
  //for UAE-FDL
  static hasUAEFDLReportViewPermission(roles) {
    return roles.includes(USER_ROLE.VIEW_GHG)
    || roles.includes(USER_ROLE.UPDATE_GHG)
  }
  static hasUAEFDLReportUpdatePermission(roles) {
    return roles.includes(USER_ROLE.UPDATE_GHG)
  }

  //for Goals and KPIs
  static hasGoalsAndKPIsViewPermission(roles) {
    return roles.includes(USER_ROLE.GOALS_AND_KPIS_VIEW)
    || roles.includes(USER_ROLE.GOALS_AND_KPIS_UPDATE)
   
  }
  static hasGoalsAndKPIsUpdatePermission(roles) { 
    return roles.includes(USER_ROLE.GOALS_AND_KPIS_UPDATE)
  

  }

  //for Double Materiality
  static hasDoubleMaterialityViewPermission(roles) {
    return roles.includes(USER_ROLE.DOUBLE_MATERIALITY_VIEW)
    || roles.includes(USER_ROLE.DOUBLE_MATERIALITY_UPDATE)
   
  }
  static hasDoubleMaterialityUpdatePermission(roles) {
    return roles.includes(USER_ROLE.DOUBLE_MATERIALITY_UPDATE)
   
  } 

  //for GHG emissions
  static hasGHGViewPermission(roles) {
    return roles.includes(USER_ROLE.GHG_EMISSIONS_VIEW)
    || roles.includes(USER_ROLE.GHG_EMISSIONS_UPDATE)
  
  }
  static hasGHGUpdatePermission(roles) {
    return roles.includes(USER_ROLE.GHG_EMISSIONS_UPDATE)
   
  }

  //for Home
  static hasHomeViewPermission(roles) {
    return roles.includes(USER_ROLE.HOME_VIEW)
    || roles.includes(USER_ROLE.HOME_UPDATE)
   
  }

  //for Dashboard
  static hasDashboardViewPermission(roles) {
    return roles.includes(USER_ROLE.DASHBOARD_UPDATE)
    || roles.includes(USER_ROLE.DASHBOARD_VIEW)
 
  }
  static hasDashboardUpdatePermission(roles) {
    return roles.includes(USER_ROLE.DASHBOARD_UPDATE)
   
  }

  //for Data Collection
  static hasDataCollectionViewPermission(roles) {
    return roles.includes(USER_ROLE.DATA_COLLECTION_VIEW)
    || roles.includes(USER_ROLE.DATA_COLLECTION_UPDATE)
  }
  static hasDataCollectionUpdatePermission(roles) { 
    return roles.includes(USER_ROLE.DATA_COLLECTION_UPDATE)
  }

  //for Configuration
  static hasConfigViewPermission(roles){
    return roles.includes(USER_ROLE.CONFIGURATIONS_VIEW)
    || roles.includes(USER_ROLE.CONFIGURATIONS_UPDATE)
  }

  static hasConfigUpdatePermission(roles){
    return roles.includes(USER_ROLE.CONFIGURATIONS_UPDATE)
  }

  //for User
  
  static hasUserViewPermission(roles){
    return roles.includes(USER_ROLE.USER_VIEW)
    || roles.includes(USER_ROLE.USER_UPDATE)
  }

  static hasUserUpdatePermission(roles){
    return roles.includes(USER_ROLE.USER_UPDATE)
  }
//for Settings User
  static hasSettingsViewPermission(roles) {
    return roles.includes(USER_ROLE.SETTINGS_VIEW)
    || roles.includes(USER_ROLE. SETTINGS_UPDATE)
  }

  static hasSettingsUpdatePermission(roles) {
    return roles.includes(USER_ROLE.SETTINGS_UPDATE)
  }

  //for chat with data
  static hasChatWithDataViewPermission(roles) {
    return roles.includes(USER_ROLE.CHAT_WITH_DATA)
  }

  static belongsToPrevilegedGroup(roles) {
    return roles.includes(USER_ROLE.REVOKE_DCE_SUBMISSION)
  }

  static hasDCERevokePermission(roles) {
    return roles.includes(USER_ROLE.REVOKE_DCE_SUBMISSION)
  }
}
